module.exports = __webpack_public_path__ + "img/img26.25a5eb53.jpg";